export default __webpack_public_path__ + "static/image9-9700f41b9402d487f803e89ea47f2980.jpg";